module.exports = __webpack_public_path__ + "img/class-notes.f25fc1b6.svg";